import { axios } from "@/lib/axios";

type AxiosResponse<T> = [ boolean, T ];

export type IplBoardType = "weekly" | "total";

export interface IplLeaderboardItemResponse {
    rank?: number;
    userId?: number;
    userName?: string;
    userAvatar?: string;
    profitAmount?: number;
}

export interface IplLeaderboardResponse {
    boardType?: IplBoardType;
    seasonCode?: string;
    seasonName?: string;
    currentWeek?: number;
    startTime?: string;
    endTime?: string;
    ended?: boolean;
    leaderboard?: IplLeaderboardItemResponse[];
    currentUserRank?: IplLeaderboardItemResponse;
}

export interface IplLeaderboardCurrentUserProfitResponse {
    boardType?: IplBoardType;
    seasonCode?: string;
    seasonName?: string;
    currentWeek?: number;
    startTime?: string;
    endTime?: string;
    ended?: boolean;
    /** Present when user is within the published rank range (e.g. top 300). */
    rank?: number;
    profitAmount?: number;
    gapToTop300ProfitAmount?: number;
    gapToTop500ProfitAmount?: number;
}

export function apiGetIplLeaderboardTop10( params: { boardType?: IplBoardType } = {} ): Promise<
    AxiosResponse<{
        data: IplLeaderboardResponse;
    }>
> {
    return axios.get( "/api/front/user/ipl-leaderboard/top10", { params } );
}

export function apiGetIplLeaderboardCurrentUserProfit(
    params: { boardType?: IplBoardType } = { boardType: "total" },
): Promise<
    AxiosResponse<{
        data: IplLeaderboardCurrentUserProfitResponse;
    }>
> {
    return axios.get( "/api/front/user/ipl-leaderboard/current-user-profit", { params } );
}
